// JS to handle when the user clicks away from the tooltip/hotspot

  document.addEventListener("DOMContentLoaded", function() {
    const hotspots = document.querySelectorAll('.hotspot');
    document.addEventListener('click', function(event) {
      hotspots.forEach(function(hotspot) {
        if (!hotspot.contains(event.target)) {
          hotspot.classList.remove('active'); 
        }
      });
    });

    hotspots.forEach(function(hotspot) {
      hotspot.addEventListener('click', function(event) {
        event.stopPropagation();
      });
    });
  });
